<div *ngIf="visibility" class="cand-modal modal-info">
    <article *ngIf="visibility" [@slideInOut] class="cand-modal__overlay">
        <em class="cand-modal__overlay__close circle-close-icon" (click)="close()"></em>
        <h1 class="cand-modal__title">
            {{ 'dashboard.projects.status.history.title' | i18n }}
        </h1>
        <section class="cand-modal__content statutdahistoryContent">
            <h3 class="statutdahistoryTitle">
                {{ 'dashboard.projects.status.history.subtitle1' | i18n }}
            </h3>
            <div class="statutdahistoryCurrent statutdahistoryCurrent--{{ dossier.emprunteur.currentAssurance.typeDashboard }}">
                <div>
                    <em class="statutdahistoryCurrentIcon iconblock--{{ dossier.emprunteur.currentAssurance.typeDashboard }}"></em>
                    <span class="statutdahistoryCurrentTitle">
                        {{ dossier.emprunteur.currentAssurance.labelStatutDA }}
                        <div class="statutdahistoryCurrentDate">
                            {{ getlisteStatutDA()[0].dateFormatted }}
                        </div>
                    </span>
                </div>
            </div>
            <h3 class="statutdahistoryTitle">
                {{ 'dashboard.projects.status.history.subtitle2' | i18n }}
            </h3>
            <ul class="statutdahistoryList">
                <li *ngFor="let statut of getlisteStatutDA().slice(1)">
                    <span>{{ 'dashboard.projects.status.' + statut.daCode + statut.ssm | i18n }}</span>
                    <span>{{ statut.dateFormatted }}</span>
                </li>
            </ul>
        </section>
    </article>
    <div *ngIf="visibility" [@fadeInOut] class="cand-modal__fade" (click)="close()"></div>
</div>
